module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_circle_right_black-8ffe293c9715b2e865cd89f85c62588b.svg";